import { AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import TaskItem from './TaskItem';

const { FiFeather } = FiIcons;

function TaskList({ tasks, onToggle, onDelete }) {
  if (!tasks.length) {
    return (
      <div className="empty-state">
        <SafeIcon icon={FiFeather} />
        <p>Nothing here yet. Enjoy the quiet.</p>
      </div>
    );
  }

  return (
    <section className="task-list" aria-live="polite">
      <AnimatePresence initial={false}>
        {tasks.map((task) => (
          <TaskItem key={task.id} task={task} onToggle={onToggle} onDelete={onDelete} />
        ))}
      </AnimatePresence>
    </section>
  );
}

export default TaskList;